/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { AgentHostPreviewHistory } from "./AgentHostPreviewHistory";
import {
  AgentHostPreviewHistoryFromJSON,
  AgentHostPreviewHistoryFromJSONTyped,
  AgentHostPreviewHistoryToJSON,
  AgentHostPreviewHistoryToJSONTyped,
} from "./AgentHostPreviewHistory";
import type { AgentHostPreview } from "./AgentHostPreview";
import {
  AgentHostPreviewFromJSON,
  AgentHostPreviewFromJSONTyped,
  AgentHostPreviewToJSON,
  AgentHostPreviewToJSONTyped,
} from "./AgentHostPreview";

/**
 *
 * @export
 * @interface AgentHostPreviewsResponse
 */
export interface AgentHostPreviewsResponse {
  /**
   *
   * @type {Array<AgentHostPreview>}
   * @memberof AgentHostPreviewsResponse
   */
  previews: Array<AgentHostPreview>;
  /**
   *
   * @type {Array<AgentHostPreviewHistory>}
   * @memberof AgentHostPreviewsResponse
   */
  history: Array<AgentHostPreviewHistory>;
}

/**
 * Check if a given object implements the AgentHostPreviewsResponse interface.
 */
export function instanceOfAgentHostPreviewsResponse(
  value: object,
): value is AgentHostPreviewsResponse {
  if (!("previews" in value) || value["previews"] === undefined) return false;
  if (!("history" in value) || value["history"] === undefined) return false;
  return true;
}

export function AgentHostPreviewsResponseFromJSON(
  json: any,
): AgentHostPreviewsResponse {
  return AgentHostPreviewsResponseFromJSONTyped(json, false);
}

export function AgentHostPreviewsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AgentHostPreviewsResponse {
  if (json == null) {
    return json;
  }
  return {
    previews: (json["previews"] as Array<any>).map(AgentHostPreviewFromJSON),
    history: (json["history"] as Array<any>).map(
      AgentHostPreviewHistoryFromJSON,
    ),
  };
}

export function AgentHostPreviewsResponseToJSON(
  json: any,
): AgentHostPreviewsResponse {
  return AgentHostPreviewsResponseToJSONTyped(json, false);
}

export function AgentHostPreviewsResponseToJSONTyped(
  value?: AgentHostPreviewsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    previews: (value["previews"] as Array<any>).map(AgentHostPreviewToJSON),
    history: (value["history"] as Array<any>).map(
      AgentHostPreviewHistoryToJSON,
    ),
  };
}
